import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);
export function formatDateTime(dateTimeString) {
    const dateTime = new Date(dateTimeString);
    const options = {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    };
    return dateTime.toLocaleString('en-US', options).replace(',', ' -');
}
export const convertToLocalTimezone = (date) => {
    if (!date)
        return null;
    const currentTimezone = dayjs.tz.guess();
    const dateInLocal = dayjs(date).tz(currentTimezone);
    if (dateInLocal.isValid()) {
        return dateInLocal.format('YYYY-MM-DDTHH:mm:ss');
    }
    else {
        return null;
    }
};
export function convertUtcToLocal(utcDateString) {
    const currentTimezone = dayjs.tz.guess();
    const localTime = dayjs.utc(utcDateString).tz(currentTimezone).format('DD/MM/YYYY HH:mm');
    return localTime;
}
export const getLocalTimeFromDate = (date) => {
    if (!date)
        return null;
    const currentTimezone = dayjs.tz.guess();
    const dateInLocal = dayjs(date).tz(currentTimezone);
    if (dateInLocal.isValid()) {
        return dateInLocal.format('HH:mm:ss');
    }
    else {
        return null;
    }
};
export function formatDateToDutch(date) {
    if (!date)
        return null;
    const d = new Date(date);
    if (isNaN(d.getTime()))
        return null;
    const formattedDateString = d.toLocaleDateString('nl-NL', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    });
    const [day, month, year] = formattedDateString.split('-').map(Number);
    const formattedDate = new Date(year, month - 1, day);
    return formattedDate;
}
export const formatDMY = (date) => {
    if (date !== null && date !== undefined)
        return dayjs(date).format('DD/MM/YYYY');
    return '';
};
export const extractTime = (dateString) => {
    if (!dateString)
        return '';
    const d = new Date(dateString);
    if (!isNaN(d.getTime())) {
        const hh = String(d.getHours()).padStart(2, '0');
        const mm = String(d.getMinutes()).padStart(2, '0');
        const ss = String(d.getSeconds()).padStart(2, '0');
        return `${hh}:${mm}:${ss}`;
    }
    const match = dateString.match(/(\d{1,2}:\d{2}(?::\d{2})?)/);
    return match ? match[1] : '';
};
export const formatDMYT = (date) => {
    if (date)
        return dayjs(date).format('DD/MM/YYYY HH:mm');
    return '';
};
export const formatRDWDate = (inputDate) => {
    try {
        let date;
        // Check if the input is in the format "YYYYMMDD" (e.g., "20230127")
        if (/^\d{8}$/.test(inputDate)) {
            let year = inputDate.substring(0, 4);
            let month = inputDate.substring(4, 6) - 1;
            let day = inputDate.substring(6, 8);
            date = new Date(year, month, day);
        }
        // Check if the input is in the format "YYYY-MM-DDTHH:mm:ss.sss" (e.g., "2024-02-14T00:00:00.000")
        else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}$/.test(inputDate)) {
            date = new Date(inputDate); // This is a valid ISO string
        }
        else {
            throw new Error('Invalid date format');
        }
        let formattedDate = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
        return formattedDate;
    }
    catch (error) {
        return 'N/A';
    }
};
